// extracted by mini-css-extract-plugin
export var bgImage = "_2p-w";
export var body = "_2p-v";
export var buttonBar = "_2p-5";
export var card = "_2p-0";
export var center = "_2p-10";
export var chevron = "_2p-14";
export var closeButton = "_2p-12";
export var collapseHeader = "_2p-6";
export var collapseIcon = "_2p-c";
export var collapseSection = "_2p-a";
export var collapseTitle = "_2p-9";
export var collapseTrigger = "_2p-7";
export var collapsed = "_2p-b";
export var dark = "_2p-1";
export var expandableCard = "_2p-15";
export var expandableCardTitle = "_2p-13";
export var grid = "_2p-4";
export var header = "_2p-e";
export var headerContainer = "_2p-d";
export var headerSubtitle = "_2p-j";
export var headerTitle = "_2p-f";
export var inherit = "_2p-8";
export var large = "_2p-h";
export var left = "_2p-11";
export var linkColor = "_2p-16";
export var medium = "_2p-i";
export var noPadding = "_2p-3";
export var outlined = "_2p-o";
export var scrollable = "_2p-2";
export var section = "_2p-n";
export var sectionHeader = "_2p-r";
export var selected = "_2p-p";
export var separator = "_2p-q";
export var subsection = "_2p-s";
export var subtitle = "_2p-t";
export var subtotalCollapseHeader = "_2p-x";
export var subtotalCollapseHeaderTitle = "_2p-y";
export var subtotalItem = "_2p-z";
export var table = "_2p-k";
export var tableCell = "_2p-m";
export var tableHeader = "_2p-l";
export var title = "_2p-u";
export var titleFullWidth = "_2p-g";